export const convertHtmlToPlainText = (string: string): string => {
    const stringWithoutHtml = string.replace(/<\/?[^>]+(>|$)/g, ''); // remove HTML tags
    return stringWithoutHtml;
};
